import { DemandBlockings } from 'api/demand-blockings/types'

export const demandBlockings: DemandBlockings[] = [
  {
    bundleId: 'se.ace.brofist',
    advertiser: 'Silvio Test Account (212218)',
    accountManager: 'John Smith',
    program: 'Tinder Dating app. Meet People (112887)',
    campaigns: [
      { cmsId: '5552442' },
      { cmsId: '1221234' },
      { cmsId: '1232334' },
      { cmsId: '1241224' },
    ],
    blockedLevel: 'product',
    publisherLevelBlocking: false,
  },
  {
    bundleId: 'alex.com',
    advertiser: 'Figma (223451)',
    accountManager: 'John Smith',
    program: 'Figma-mobile (181273)',
    campaigns: [
      { cmsId: '5542421' },
      { cmsId: '1213422' },
      { cmsId: '1212432' },
      { cmsId: '1212342' },
      { cmsId: '1212312' },
      { cmsId: '1221234' },
    ],
    blockedLevel: 'advertiser',
    publisherLevelBlocking: false,
  },
  {
    bundleId: 'All applications',
    advertiser: 'Jo Inc (223411)',
    accountManager: 'John Smith',
    program: 'Jo-Jo (181275)',
    campaigns: [{ cmsId: '5541421' }, { cmsId: '1211422' }],
    blockedLevel: 'advertiser',
    publisherLevelBlocking: true,
  },
]
